import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {EntityKey} from '../../entity/entity';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {SelectionItem} from '../../selections/selection-item';
import {EntityService} from '../../services/entity-service';
import {SelectionService} from '../../services/selection-service';
import {StringUtils} from '../../utils/string-utils';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'entity-cancel-dialog',
    templateUrl: './entity-cancel-dialog.component.html',
    styleUrls: ['./entity-cancel-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatProgressSpinner, MatDialogActions, MatButton]
})
export class EntityCancelDialogComponent {
  private readonly entityService = inject(EntityService);
  private readonly selectionService = inject(SelectionService);
  dialogRef = inject<MatDialogRef<EntityCancelDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public entityKey: EntityKey;
  public entityLines: EntityLineHeader[];
  readonly errorMessage = signal<string>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);
  public reasonCode!: string;
  readonly reasonCodes = signal<SelectionItem[]>(undefined!);

  constructor
  () {
    const data = this.data;

    this.entityKey = data.entityKey as EntityKey;
    this.entityLines = data.entityLines as EntityLineHeader[];
    this.selectionService.getCancelReasons(this.entityKey.entityName).subscribe(results => this.reasonCodes.set(results), error => this.handleError(error));
  }

  public abort(): void {
    this.dialogRef.close(null);
  }

  public proceed(): void {
    this.isBusy.set(true);
    if (this.entityLines && this.entityLines.length > 0) {
      this.dialogRef.close(this.reasonCode);
    } else {
      this.entityService.cancel(this.entityKey, this.reasonCode).subscribe(result => {
        this.isBusy.set(false);
        this.dialogRef.close(result);
      }, error => this.handleError(error));
    }
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
